/* eslint-disable @nx/enforce-module-boundaries */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
import { ShellTrackHandlers } from '@cigna/cigna-for-brokers/shared/analytics-util';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'cigna-brk-statement-access-request',
  templateUrl: './statement-access-request.component.html',
  styleUrls: ['./statement-access-request.component.scss'],
})
export class StatementAccessRequestComponent implements OnInit {
  @Input() isFromHome: boolean;
  @Input() isImpersonatorFlag: boolean;

  @Output() contactUsClickEvent = new EventEmitter();

  constructor(
    public _appStateFacade: AppstateFacade,
    public analytics: ShellTrackHandlers,
    private router: Router,
  ) {}

  userPeId = '';
  profileData$ = this._appStateFacade.isProfileUser$;
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    if (this.isFromHome) {
      this._appStateFacade.setStatementAccessRequest(true);
    }

    this.profileData$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((res: any) => {
        if (res) {
          const objPeid = res.accessTokenBody['cigna.userPeId'];
          this.userPeId = objPeid;
        }
      });
  }
  trackLinkClick(): void {
    if (this.isFromHome && !this.isImpersonatorFlag) {
      this.analytics.trackEventOther({}, 'email', 'ac24429', {
        eVar119: 'MTD-1439',
        eVar120: 'compensation-links',
        prop67: 'action',
        channel: 'Home',
        prop51: 'U.S. Employer',
        prop20: 'compensation',
        pageName: 'Dashboard',
      });
    } else {
      if (!this.isImpersonatorFlag) {
        this.analytics.trackEventOther({}, 'email', 'ac24433', {
          eVar119: 'MTD-1450',
          eVar120: 'request-statement-access-modal-links',
          prop20: 'request statement access modal',
          prop67: 'action',
          channel: 'Home',
          pageName: 'Dashboard',
        });
      }
    }
  }

  navigateContactUs() {
    if (!this.isImpersonatorFlag) {
      this.contactUsClickEvent.emit();
      this.router.navigate(['/secure/home/contact-us']);
    }
  }
}
